
export var DAYS_OF_WEEK = [ "sun", "mon", "tue", "wed", "thu", "fri", "sat" ];

export var DEFAULT_TERRITORY = '001';



//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/cldr/constants.js
// module id = 390
// module chunks = 93